import localforage from 'localforage'

export const farmStore = localforage.createInstance({ name: 'farmStore' })
export const zoneStore = localforage.createInstance({ name: 'zoneStore' })
export const lotStore = localforage.createInstance({ name: 'lotStore' })
export const animalStore = localforage.createInstance({ name: 'animalStore' })

export const eventStore = localforage.createInstance({ name: 'eventStore' })

export const idMapStore = localforage.createInstance({ name: 'idMapStore' })
export const syncQueue = localforage.createInstance({ name: 'syncQueue' })